import Pusher from 'pusher-js'
import Cookies from 'js-cookie'

const token = Cookies.get('SMARTCAF_JWT_TOKEN')

const pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
  cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
  authEndpoint: `${process.env.REACT_APP_HOST}api/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: token,
    },
  },
})

export const initializePusher = (isAuth = true) => {
  let pusher
  if (isAuth) {
    const token = Cookies.get('SMARTCAF_JWT_TOKEN')

    pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
      cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
      authEndpoint: `${process.env.REACT_APP_HOST}api/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: token,
        },
      },
    })
  } else {
    pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY, {
      cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    })
  }

  return pusher
}

export default pusher
